const YOUTUBE_PLAYER_READY_TIMEOUT_MS = 12_000;

const MAX_FOCUS_FRAMES = 5;

const HIDE_PARTNER_TUTORIALS_KEY = 'hide-partner-tutorials';

export { HIDE_PARTNER_TUTORIALS_KEY, MAX_FOCUS_FRAMES, YOUTUBE_PLAYER_READY_TIMEOUT_MS };
